import { useCallback, useEffect, useRef, useState } from 'react';

// Director tenant switcher — v1 stub.
// Visible only for Director role. Shows "All Tenants" dropdown.
// Real tenant impersonation is a separate dispatch.

export function DirectorTenantSwitcher() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        close();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open, close]);

  return (
    <div className="sp-tenant-switcher" ref={ref}>
      <button
        className="sp-tenant-switcher-trigger"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="sp-tenant-switcher-label">All Tenants</span>
        <span className="sp-tenant-switcher-caret">{open ? '\u25B4' : '\u25BE'}</span>
      </button>

      {open && (
        <div className="sp-tenant-switcher-dropdown">
          <div className="sp-tenant-switcher-item sp-tenant-switcher-item--selected">
            All Tenants
          </div>
          <div className="sp-tenant-switcher-note">
            Tenant impersonation — build in progress
          </div>
        </div>
      )}
    </div>
  );
}
